import { render, staticRenderFns } from "./AttributeDataView.vue?vue&type=template&id=2ef5dbef"
import script from "./AttributeDataView.vue?vue&type=script&lang=ts"
export * from "./AttributeDataView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports